/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import { Select } from '@react-three/postprocessing'
import { type JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

import { toLambert } from '@utils'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      Sign12_1: Mesh
      Sign12_2: Mesh
      Sign12_3: Mesh
      Sign12_4: Mesh
    }
    materials: {
      ['Light Wood']: MeshStandardMaterial
      ['Dark Wood']: MeshStandardMaterial
      Herbs: MeshStandardMaterial
      Rocks: MeshStandardMaterial
    }
  }

type WoodenSignModelProps = JSX.IntrinsicElements['group'] & {
  highlight?: boolean
}

export function WoodenSignModel({
  highlight,
  onClick,
  onPointerOver,
  onPointerOut,
  onPointerEnter,
  onPointerLeave,
  ...props
}: WoodenSignModelProps) {
  const { nodes, materials } = useGLTF('/models/wooden-sign.glb') as GLTFResult

  return (
    <group {...props}>
      <group scale={100}>
        <Select enabled={highlight}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Sign12_1.geometry}
            material={toLambert(materials['Light Wood'])}
            onClick={onClick}
            onPointerOver={onPointerOver}
            onPointerOut={onPointerOut}
            onPointerEnter={onPointerEnter}
            onPointerLeave={onPointerLeave}
          />
        </Select>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sign12_2.geometry}
          material={toLambert(materials['Dark Wood'])}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sign12_3.geometry}
          material={toLambert(materials.Herbs)}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sign12_4.geometry}
          material={toLambert(materials.Rocks)}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/models/wooden-sign.glb')
